<template>
    <span class="tag" :class="stateClasses">{{ translatedDisplay }}</span>
</template>
<script>
  import State from '@/classes/case/State'

  export default {
    name: 'status-component',
    props: {
      display: {
        type: String,
        required: true
      },
      level: {
        type: Number,
        required: true
      },
      custom_classes: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      stateClasses () {
        return `${State.getStateClass(this.level)} ${this.custom_classes.join(' ')}`
      },
      translatedDisplay () {
        return this.$gettext(this.display)
      }
    }
  }
</script>
